document.addEventListener('DOMContentLoaded', function () {
  new Swiper('.swiper-new-arrivals-products', {
    slidesPerView: 'auto',
    spaceBetween: 4,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      1024: {
        spaceBetween: 0,
        slidesPerView: 'auto',
      },
    },
    grabCursor: false,
  });
});
